/* eslint-disable import/prefer-default-export */
export enum UpdateProfileStepId {
  PlayerInfo = "UpdatePlayerInfo",
  CoachInfo = "UpdateCoachInfo",
  ClubInfo = "UpdateClubInfo",
}
